import ScrollHandIcon from '../icon/ScrollHandIcon';
import ArrowScrollIcon from '../icon/ArrowScrollIcon';
import { cn } from '@/utils/utils';

export default function ScrollTableGuide({ showHint = false, className = '' }: { showHint: boolean, className?: string }) {
    return (
        showHint ?
            (
                <div className={cn(
                    'absolute left-1/2 top-1/3 -translate-x-1/2 z-10 flex flex-col items-center justify-center gap-1 bg-black/70 text-white py-2 px-4 rounded pointer-events-none animate-fadeIn',
                    className
                )}
                >
                    <div>
                        <ArrowScrollIcon />
                    </div>
                    <div className='animate-swipe-left'>
                        <ScrollHandIcon></ScrollHandIcon>
                    </div>
                    <div className='text-xs whitespace-nowrap'>横にスクロール</div>
                </div>
            ) :
            <></>
    );
}
